import { render, staticRenderFns } from "./delete-api-key.vue?vue&type=template&id=667bf94e"
import script from "./delete-api-key.vue?vue&type=script&lang=js"
export * from "./delete-api-key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports